import { z } from 'zod'

export const ManufacturerSearchItemSchema = z.object({
  id: z.string().uuid(),
  displayName: z.string().min(1).max(120).refine((name) => name.trim().length > 0),
  analyticsKey: z.string().min(1).max(160),
}).strict()

export const ManufacturerSearchResponseSchema = z.object({
  items: z.array(ManufacturerSearchItemSchema).max(20),
}).strict()

export type ManufacturerSearchItem = z.infer<typeof ManufacturerSearchItemSchema>
